import { Fragment } from "react";

import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

import Divider from "components/DesignComponents/Divider";
import { useMediaQueries } from "shared/hooks/useMediaQueries";

interface DeviceStatsInitialDrawerLoaderProps {
    isLast: boolean;
}

const DeviceStatsInitialDrawerLoader = ({
    isLast
}: DeviceStatsInitialDrawerLoaderProps) => {
    const { gray100 } = colors;

    const { fromMd } = useMediaQueries();

    return (
        <Fragment>
            <Skeleton
                variant="rectangular"
                width="100%"
                height={228}
                css={css({
                    backgroundColor: gray100,
                    marginBottom: fromMd && isLast ? "16px" : "0",
                    marginTop: "12px",
                    borderRadius: "6px"
                })}
            />

            {!isLast && <Divider hasMarginOnTop={true} />}
        </Fragment>
    );
};

export default DeviceStatsInitialDrawerLoader;
